// Frozen list of building variants used by the cost-tracking screens.
// Procedural generator is seeded (briefIndex = 0), so each (length, width,
// floors) tuple always produces an identical building. The detail screen
// regenerates from this list by index, so the building shown there matches
// the one in the grid tile.
export type CostTrackingVariant = {
  label: string;
  kind: "square" | "rect";
  length: number;
  width: number;
  floors: number;
};

export const COST_TRACKING_VARIANTS: CostTrackingVariant[] = [
  // Squares
  { label: "Small · Low", kind: "square", length: 25, width: 25, floors: 3 },
  { label: "Small · Mid", kind: "square", length: 25, width: 25, floors: 5 },
  { label: "Small · High", kind: "square", length: 25, width: 25, floors: 8 },
  { label: "Medium · Low", kind: "square", length: 35, width: 35, floors: 3 },
  { label: "Medium · Mid", kind: "square", length: 35, width: 35, floors: 5 },
  { label: "Medium · High", kind: "square", length: 35, width: 35, floors: 8 },
  { label: "Large · Low", kind: "square", length: 50, width: 50, floors: 3 },
  { label: "Large · Mid", kind: "square", length: 50, width: 50, floors: 5 },
  { label: "Large · High", kind: "square", length: 50, width: 50, floors: 8 },
  { label: "Tall", kind: "square", length: 30, width: 30, floors: 12 },
  // Rectangles — varied aspect ratios + heights
  { label: "Rect · Bar", kind: "rect", length: 60, width: 25, floors: 5 },
  { label: "Rect · Wide", kind: "rect", length: 60, width: 30, floors: 3 },
  { label: "Rect · Mid", kind: "rect", length: 45, width: 30, floors: 6 },
  { label: "Rect · Tower", kind: "rect", length: 30, width: 25, floors: 10 },
  { label: "Rect · Extended", kind: "rect", length: 50, width: 30, floors: 7 },
];

// Match DEFAULT_COST_SETTINGS in Api.ts:32 — what the worker uses for an
// unknown projectId with no localStorage entry.
export const COST_TRACKING_SETTINGS = { prelims: 10, contingency: 3, ohp: 5.5 };
